import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class SpotService {
  private urlFromSearchDtoEndpoint: string =
    "/spotbuildings/search/url-by-search-dto";
  currentCode: string;

  constructor(private http: HttpClient) {
    this.currentCode = environment.platformId;
  }

  async getUrlFromListingsSearchDto(
    latamCountry: string,
    searchDto: any
  ): Promise<any> {
    let legacyUrl: string;

    const currentCode = this.currentCode;

    if (this.currentCode !== "latam") {
      legacyUrl = environment.apiURL;
    } else if (latamCountry === "latamMx" || currentCode === "co") {
      legacyUrl = environment.apiURLMX;
    } else {
      legacyUrl = environment.apiURLBR;
    }
    const envURL = legacyUrl;
    const searchDTOURL = `${envURL}${this.urlFromSearchDtoEndpoint}`;

    return await this.http.post(searchDTOURL, searchDto).toPromise();
  }
}
